const spareUtregning = (
    antallAar: number,
    sparingPerMnd: number,
    renteProsent: number,
    inflasjonProsent: number,
    oppspart: number
): number => {
    const desimalRealRente = (renteProsent - inflasjonProsent) / 100;
    let spareBelop = oppspart;
    for (let i = 0; i < antallAar; i += 1) {
        for (let j = 0; j < 12; j += 1) {
            spareBelop += sparingPerMnd;
            spareBelop *= (1 + desimalRealRente) ** (1 / 12);
        }
    }
    return spareBelop;
};

export default spareUtregning;
